import { localRequest, appHost } from "./uri";
import axios from "axios";
import is_null from "./is_null";

/**
 * Convert technical error messages to user-friendly messages
 */
const getUserFriendlyError = (error) => {
  const errorString = error?.toString()?.toLowerCase() || "";

  // Database connection errors
  if (errorString.includes("enotfound") || errorString.includes("mongodb.net")) {
    return "Unable to connect to the server. Please check your internet connection and try again.";
  }
  if (errorString.includes("etimedout") || errorString.includes("timeout")) {
    return "The server is taking too long to respond. Please try again later.";
  }
  if (errorString.includes("econnrefused")) {
    return "Cannot connect to the server. The service may be temporarily unavailable.";
  }
  if (errorString.includes("network error") || errorString.includes("network_error")) {
    return "Network connection error. Please check your internet connection.";
  }
  if (errorString.includes("500") || errorString.includes("internal server")) {
    return "Something went wrong on our end. Please try again later.";
  }
  if (errorString.includes("401") || errorString.includes("unauthorized")) {
    return "Your session has expired. Please sign in again.";
  }
  if (errorString.includes("403") || errorString.includes("forbidden")) {
    return "You don't have permission to perform this action.";
  }
  if (errorString.includes("404") || errorString.includes("not found")) {
    return "The requested resource was not found.";
  }

  // Return original if no match
  return error;
};

export const axiosget = async (requestLink, Payload, fullHeader) => {
  try {
    const isAuthenticated = localStorage.getItem("isApplicant");
    let header = {};
    if (!is_null(isAuthenticated)) {
      header = {
        headers: {
          authorization: "Bearer " + isAuthenticated,
        },
        body: Payload,
      };
    }
    if (!is_null(fullHeader)) {
      header = fullHeader;
    }
    const url = localRequest + requestLink;
    const req = await axios.get(url, header);
    return req;
  } catch (ex) {
    const full = { ...ex };
    if (full.response !== undefined) {
      const { message } = full.response.data;
      if (message !== undefined && message.toString().includes("expired")) {
        localStorage.removeItem("isApplicant");
        window.location.href = appHost;
      } else {
        return { type: "error", message: getUserFriendlyError(message) };
      }
    } else {
      const { message } = full;
      return { type: "error", error: getUserFriendlyError(message) };
    }
  }
};

export const axiospost = async (requestLink, PayLoad, fullHeader) => {
  try {
    const isAuthenticated = localStorage.getItem("isApplicant");
    let header = {};
    if (isAuthenticated !== undefined && isAuthenticated !== null) {
      header = {
        headers: {
          authorization: "Bearer " + isAuthenticated,
        },
      };
    } else {
      if (fullHeader !== undefined && fullHeader !== null) {
        header = fullHeader;
      }
    }
    const url = localRequest + requestLink;

    const req = await axios.post(url, PayLoad, header);

    return req;
  } catch (ex) {
    const full = { ...ex };
    if (full.response !== undefined) {
      const { error, message } = full.response.data;
      if ((error !== undefined && error.toString().includes("expired")) ||
          (message !== undefined && message.toString().includes("expired"))) {
        localStorage.removeItem("isApplicant");
        window.location.href = appHost;
      } else {
        return { type: "error", message: getUserFriendlyError(message) };
      }
    } else {
      const { message } = full;
      return { type: "error", error: getUserFriendlyError(message) };
    }
  }
};

export const axiosput = async (requestLink, PayLoad, fullHeader) => {
  try {
    const isAuthenticated = localStorage.getItem("isApplicant");
    let header = {};
    if (isAuthenticated !== undefined && isAuthenticated !== null) {
      header = {
        headers: {
          authorization: "Bearer " + isAuthenticated,
        },
      };
    } else {
      if (fullHeader !== undefined && fullHeader !== null) {
        header = fullHeader;
      }
    }
    if (isAuthenticated === undefined) throw new Error("Sorry you need to be signed in to perform this transaction");
    const url = localRequest + requestLink;

    const req = await axios.put(url, PayLoad, header);
    return req;
  } catch (ex) {
    const full = { ...ex };
    if (full.response !== undefined) {
      const { error, message } = full.response.data;
      if ((error !== undefined && error.toString().includes("expired")) ||
          (message !== undefined && message.toString().includes("expired"))) {
        localStorage.removeItem("isApplicant");
        window.location.href = appHost;
      } else {
        return { type: "error", error: getUserFriendlyError(error || message) };
      }
    } else {
      const { message } = full;
      return { type: "error", error: getUserFriendlyError(message) };
    }
  }
};

export const axiosdelete = async (requestLink, PayLoad, fullHeader) => {
  try {
    const isAuthenticated = localStorage.getItem("isApplicant");
    let header = {};
    if (isAuthenticated !== undefined && isAuthenticated !== null) {
      header = {
        headers: {
          authorization: "Bearer " + isAuthenticated,
          body: PayLoad,
        },
      };
    } else {
      if (fullHeader !== undefined && fullHeader !== null) {
        header = fullHeader;
      }
    }
    const url = localRequest + requestLink;

    const req = await axios.delete(url, header);
    return req;
  } catch (ex) {
    const full = { ...ex };
    if (full.response !== undefined) {
      const { error, message } = full.response.data;
      if ((error !== undefined && error.toString().includes("expired")) ||
          (message !== undefined && message.toString().includes("expired"))) {
        localStorage.removeItem("isApplicant");
        window.location.href = appHost;
      } else {
        return { type: "error", error: getUserFriendlyError(error || message) };
      }
    } else {
      const { message } = full;
      return { type: "error", error: getUserFriendlyError(message) };
    }
  }
};
